import './App.css';
import Dashboard from '../Dashboard/Dashboard';
import Preferences from '../Preferences/Preferences';
import {Routes, Route} from 'react-router-dom';
import Login from '../Login/Login';
import React,{useState} from 'react';
import useToken from './useToken';
import Singup from '../Singup/Singup';
import Navbar from '../Navbar/Navbar';
import Contact from '../Contact/Contact';
import FourOFour from '../FourOFour/FourOFour';



function App() {
  const { token, setToken } = useToken();

  if(!token) {
    return( 
      <>
      <Routes>
     <Route exact path="/"  element={<Login setToken={setToken} />} /> 
     <Route path="*" element={<FourOFour/>}/>
      <Route  exact path="/singup"  element={<Singup />}/>
      </Routes>
      </>
      
      )
  }

  return (
  <>

 
<Navbar/>
    <Routes>
  
    <Route path="/" element={<Dashboard />}/>
   <Route path="/preferences" element={<Preferences/>}/>
   <Route path="/login" element={<Login />}/>
   <Route path="*" element={<FourOFour/>}/>

   <Route path="/contact" element={<Contact />}/>
    </Routes>

  </>
  );
}

export default App;

